// extracted by mini-css-extract-plugin
export default {"cardsContainer":"Cards_cardsContainer__luE6X","cardsGrid":"Cards_cardsGrid__KKnSs"};